import * as React from "react";
const SvgFiRrTrashXmark = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M15.707 11.707 13.414 14l2.293 2.293a.999.999 0 1 1-1.414 1.414L12 15.414l-2.293 2.293a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414L10.586 14l-2.293-2.293a.999.999 0 1 1 1.414-1.414L12 12.586l2.293-2.293a.999.999 0 1 1 1.414 1.414M23 5a1 1 0 0 1-1 1h-.885l-1.276 13.472A4.98 4.98 0 0 1 14.861 24H9.134a4.98 4.98 0 0 1-4.977-4.521L2.861 6h-.86a1 1 0 1 1 0-2h4.101a5.01 5.01 0 0 1 4.899-4h2A5.01 5.01 0 0 1 17.9 4h4.101c.552 0 .999.447.999 1M8.172 4h7.656A3 3 0 0 0 13 2h-2a3 3 0 0 0-2.828 2m10.934 2H4.87l1.278 13.287A2.987 2.987 0 0 0 9.134 22h5.727a2.99 2.99 0 0 0 2.987-2.718z"
    />
  </svg>
);
export default SvgFiRrTrashXmark;
